/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-27 16:02:16
 * @LastEditors: K
 * @LastEditTime: 2022-10-09 09:27:30
 */
import { unwrapResult } from "@reduxjs/toolkit"
import {
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  Table,
  Tabs,
  Tag,
} from "antd"
import moment from "moment"
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../app/store"
import { ThemeContext } from "../../theme/ThemeContext"
import { DateTimeFormatSimple } from "../../models/datetime"
import styles from "./outRecipe.module.css"
import { serverType } from "../../services/commodity"
import { selectInsuranceItem } from "../../layouts/insuranceSlice"
import { medicalSendHttp, strParse } from "../../utils/MedicalUtils"
import {
  getMatchDrugInventoryAsync,
  outRecipeSubmitDataAsync,
  searchOutRecipeDataAsync,
} from "../registration/register/registerSlice"
import { getSFDoctorListAsync } from "../sales/DoctorAccont/doctorAuditSlice"
import { User } from "../../models/user"
import { EditableList } from "../../compnents/list/EditableList"

interface InformationModalProps {
  currentTreatmentId:number,
  visible: boolean
  insuranceItem: any
  outRecipeList: any[]
  patientInsurance: any
  onCancel: () => void
  onOk: (data: any, disease: any, rxNo: string) => void
}

export const OutRecipeModal = ({
  currentTreatmentId,
  visible,
  insuranceItem,
  outRecipeList,
  patientInsurance,
  onCancel,
  onOk,
}: InformationModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const timerRef = useRef<NodeJS.Timeout | null>(null)

  const [form] = Form.useForm()

  const baseData = useSelector(selectInsuranceItem)

  const { CheckableTag } = Tag

  const { Option } = Select

  const { TextArea } = Input

  const [activeKey, setActiveKey] = useState("1")

  const [data, setData] = useState<any>()

  const [pdfUrl, setPdfUrl] = useState("")

  const [pdfLoading, setPdfLoading] = useState(true)

  const [doctors, setDoctors] = useState<User[]>([])

  const [medicalVisible, setMedicalVisible] = useState(false)

  const [btnLoading, setBtnLoading] = useState(false)

  const [medicalLoading, setMedicalLoading] = useState(false)

  const [medicalList, setMedicalList] = useState<any>([])
  
  const [medicalItemList, setMedicalItemList] = useState<any>([])

  const [prescription, setPrescription] = useState<any>({})

  const [prescriptionCurrent, setPrescriptionCurrent] = useState<any>({})

  const getStatus = (type: string) => {
    switch (type) {
      case "0":
        return "否"
      case "1":
        return "是"
      default:
        return ""
    }
  }

  // 查询外配处方
  const searchOutRecipeData = (
    isShowModal: boolean,
    serverType: serverType,
    ybPersonalNo: string,
    insuranceRegion: string,
    epcToken: string,
    authRxno: string,
    treatmentId?: number,
    responseString?: string,
  ) => {
    dispatch(
      searchOutRecipeDataAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          ybPersonalNo,
          insuranceRegion,
          epcToken,
          authRxno,
          treatmentId
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === "requestString") {
          const data = strParse(res)
          // searchOutRecipeData(
          //   isShowModal,
          //   "response",
          //   psnNo,
          //   insuranceRegion,
          //   epcToken,
          //   authRxno,
          //   "test#test"
          // )

          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
              message: '外配处方下载',
            },
            (call: any, err) => {
              if (!err) {
                searchOutRecipeData(
                  isShowModal,
                  'response',
                  ybPersonalNo,
                  insuranceRegion,
                  epcToken,
                  authRxno,
                  treatmentId,
                  JSON.stringify(call.netmessage)
                  //'test#test'
                )
              }
            }
          )
        } else {
          setData(res?.prescriptionInfo)
          setPdfUrl(
            `data:application/pdf;base64,${res?.prescriptionInfo?.data?.rx_file}`
          )
          timerRef.current = setTimeout(() => {
            setPdfLoading(false)
          }, 1000)
        }
      })
  }

  // 外配处方保存
  const outRecipeSubmit = (
    isShowModal: boolean,
    serverType: serverType,
    pharId: number,
    rchkPharId: number,
    dspeerId: number,
    rxChkStas: number,
    rxChkOpnn: string,
    rxTraceCode: string,
    hiRxno: string,
    rxFile: string,
    medType: string,
    epcToken: string,
    insuranceRegion: string,
    responseString?: string,
    treatmentId?:number
  ) => {
    setBtnLoading(true)
    dispatch(
      outRecipeSubmitDataAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          pharId,
          rchkPharId,
          dspeerId,
          rxChkStas,
          rxChkOpnn,
          rxTraceCode,
          hiRxno,
          rxFile,
          medType,
          epcToken,
          insuranceRegion,
          treatmentId
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === "requestString") {
          const data = strParse(res)
          // outRecipeSubmit(
          //   isShowModal,
          //   "response",
          //   pharId,
          //   rchkPharId,
          //   dspeerId,
          //   rxChkStas,
          //   rxChkOpnn,
          //   rxTraceCode,
          //   hiRxno,
          //   rxFile,
          //   "test#test"
          // )

          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
              message: '外配处方审核',
            },
            (call: any, err) => {
              if (!err) {
                outRecipeSubmit(
                  isShowModal,
                  'response',
                  pharId,
                  rchkPharId,
                  dspeerId,
                  rxChkStas,
                  rxChkOpnn,
                  rxTraceCode,
                  hiRxno,
                  '',
                  medType,
                  epcToken,
                  insuranceRegion,
                  JSON.stringify(call.netmessage),treatmentId
                  //'test#test'
                )
              } else {
                setBtnLoading(false)
              }
            }
          )
        } else {
          const result = res.output.data
          setBtnLoading(false)
          Modal.confirm({
            centered: true,
            title:
              result.flag == "true"
                ? "电子处方信息审核成功"
                : "电子处方信息审核失败",
            content: (
              <div>
                <p>
                  签名机构证书 SN：{result.rx_info_verify_result.sign_cert_sn}
                </p>
                <p>
                  签名机构证书 DN{result.rx_info_verify_result.sign_cert_dn}
                </p>
                <p>
                  处方签名验签流水号：
                  {result.rx_info_verify_result.rx_sign_verify_sn}
                </p>
              </div>
            ),
            okText: "确认",
            cancelText: "取消",
            icon: null,
            onOk: () => {
              dispatch(getMatchDrugInventoryAsync(data?.rxDetlList))
              .then(unwrapResult)
              .then((v: any) => {
                setMedicalList(v?.rxDetlList)
                setMedicalItemList(v?.inventoryDetls?.map((r: any) => {
                  return { ...r, sellUnit: r.accountUnit }
                }))
                setMedicalVisible(true)
              })
            },
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  useEffect(() => {
    if (visible && outRecipeList?.length) {
      setPrescription(outRecipeList?.[0]?.auth_rxno)
      setPrescriptionCurrent(outRecipeList?.[0])
      searchOutRecipeData(
        true,
        "requestString",
        patientInsurance?.ybPersonalNo,
        patientInsurance?.insuranceRegion,
        outRecipeList?.[0]?.epc_token,
        outRecipeList?.[0]?.auth_rxno,
        currentTreatmentId
      )
    } else {
      setData(null)
      setPdfUrl('')
      setPdfLoading(true)
      setBtnLoading(false)
    }
  }, [visible, outRecipeList])

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    }
  }, [])

  useEffect(() => {
    if (visible)
      dispatch(getSFDoctorListAsync())
        .then(unwrapResult)
        .then((doctors) => setDoctors(doctors))
  }, [visible])

  return (
    <Modal
      visible={visible}
      title="外配处方"
      width={1500}
      cancelText="取消"
      maskClosable={false}
      okText="确定"
      confirmLoading={btnLoading}
      onCancel={onCancel}
      onOk={form.submit}
    >
      <Form
        form={form}
        // colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{
          rxChkStas: 1,
        }}
        autoComplete="off"
        onFinish={(values) => {
          outRecipeSubmit(
            true,
            "requestString",
            values.pharId,
            values.rchkPharId,
            values.dspeerId,
            values.rxChkStas,
            values.rxChkOpnn,
            data?.data?.rx_trace_code,
            data?.data?.hi_rxno,
            data?.data?.rx_file,
            data.rxOtpinfo?.med_type,
            prescriptionCurrent?.epc_token,
            patientInsurance?.insuranceRegion,
            undefined,
            currentTreatmentId
          )
        }}
      >
        <Row>
          <Col span={12} style={{ display: 'flex', alignItems: 'center',marginBottom: 20 }}>
              <span>选择处方：</span>
              <Select allowClear value={prescription} style={{ width: 300 }} onChange={(v) => {
                const item = outRecipeList?.find((m: any) => m.auth_rxno === v)
                setPrescription(item?.auth_rxno)
                setPrescriptionCurrent(item)
                searchOutRecipeData(
                  true,
                  "requestString",
                  patientInsurance?.ybPersonalNo,
                  patientInsurance?.insuranceRegion,
                  item?.epc_token,
                  v,
                )
              }}>
                {outRecipeList
                  ?.map((d) => (
                    <Select.Option key={d.auth_rxno} value={d?.auth_rxno}>
                      {d?.fixmedins_name + ' ' + d?.prsc_time}
                    </Select.Option>
                  ))}
              </Select>
          </Col>
          <Col span={18} className={styles.recipeTabs}>
            <Tabs
              activeKey={activeKey}
              // className={styles.patientInfoTabs}
              onChange={(v) => {
                setActiveKey(v)
                if (v != activeKey) {
                  setPdfLoading(true)
                  timerRef.current && clearTimeout(timerRef.current)
                  timerRef.current = setTimeout(() => {
                    setPdfLoading(false)
                  }, 1000)
                }
              }}
              destroyInactiveTabPane
            >
              <Tabs.TabPane tab="处方详细信息" key="1">
                <Row>
                  <Col span={12}>
                    <Row className={styles.recipeRow}>
                      <Col span={24}>
                        定点医疗机构名称：{data?.data?.fixmedins_name}
                      </Col>
                      <Col span={24}>
                        定点医疗机构编号：{data?.data?.fixmedins_code}
                      </Col>
                      <Col span={24}>医保处方编号：{data?.data?.hi_rxno}</Col>
                      <Col span={24}>开方时间：{data?.data?.prsc_time}</Col>
                      <Col span={24}>
                        处方追溯码：{data?.data?.rx_trace_code}
                      </Col>
                      <Col span={24}>
                        开方科室名称：{data?.data?.prsc_dept_name}
                      </Col>
                      <Col span={24}>
                        处方类别名称：{data?.data?.rx_type_name}
                      </Col>
                      <Col span={24}>
                        长期处方标志：{getStatus(data?.data?.long_rx_flag)}
                      </Col>
                    </Row>
                  </Col>
                  <Col span={12} style={{ position: "relative" }}>
                    <iframe
                      src={`${pdfUrl}#view=Fit&toolbar=0&navpanes=0`}
                      width="80%"
                      height="555px"
                      style={{
                        border: "none",
                        backgroundColor: "transparent",
                        padding: "0",
                        margin: "0 auto",
                      }}
                    />
                    {pdfLoading && <div className={styles.pdfMask}></div>}
                  </Col>
                </Row>
              </Tabs.TabPane>
              <Tabs.TabPane tab="处方门诊信息" key="2">
                <Row className={styles.recipeRow}>
                  <Col span={12}>医疗类别：{data?.rxOtpinfo?.med_type}</Col>
                  <Col span={12}>患者姓名：{data?.rxOtpinfo?.patn_name}</Col>
                  <Col span={12}>年龄：{data?.rxOtpinfo?.patn_age}</Col>
                  <Col span={12}>性别：{data?.rxOtpinfo?.gend}</Col>
                  <Col span={12}>
                    新生儿标志：{getStatus(data?.rxOtpinfo?.nwb_flag)}
                  </Col>
                  <Col span={12}>过敏史：{data?.rxOtpinfo?.algs_his}</Col>
                  <Col span={12}>病种编码：{data?.rxOtpinfo?.dise_codg}</Col>
                  <Col span={12}>
                    主诊断代码：{data?.rxOtpinfo?.main_diag_code}
                  </Col>
                  <Col span={12}>
                    主诊断名称：{data?.rxOtpinfo?.main_diag_name}
                  </Col>
                  <Col span={12}>
                    疾病病情描述：{data?.rxOtpinfo?.dise_cond_dscr}
                  </Col>
                </Row>
              </Tabs.TabPane>
              <Tabs.TabPane tab="处方药品信息" key="3">
                <Table
                  rowKey={() => `row_${Math.random()}`}
                  pagination={false}
                  size="small"
                  bordered
                  columns={[
                    {
                      title: "医疗目录编码",
                      align: "center",
                      dataIndex: "med_list_codg",
                      width: "14rem",
                      ellipsis: true,
                    },
                    {
                      title: "药品商品名",
                      align: "center",
                      dataIndex: "drug_prodname",
                      width: "8rem",
                      ellipsis: true,
                    },
                    {
                      title: "药品剂型",
                      align: "center",
                      dataIndex: "drug_dosform",
                      width: "80px",
                      ellipsis: true,
                    },
                    {
                      title: "药品规格",
                      align: "center",
                      dataIndex: "drug_spec",
                      width: "80px",
                      ellipsis: true,
                    },
                    {
                      title: "药品总量",
                      align: "center",
                      dataIndex: "drug_cnt",
                      width: "80px",
                      ellipsis: true,
                    },
                    {
                      title: "用药描述",
                      align: "center",
                      dataIndex: "medc_way_dscr",
                      width: "80px",
                      ellipsis: true,
                    },
                    {
                      title: "药品总量单位",
                      align: "center",
                      dataIndex: "drug_dosunt",
                      ellipsis: true,
                    },
                    {
                      title: "单次用量",
                      align: "center",
                      dataIndex: "sin_doscnt",
                      width: "80px",
                      ellipsis: true,
                    },
                    {
                      title: "单次剂量单位",
                      align: "center",
                      dataIndex: "sin_dosunt",
                      ellipsis: true,
                    },
                    {
                      title: "使用频次",
                      align: "center",
                      dataIndex: "used_frqu_name",
                      width: "80px",
                      ellipsis: true,
                    },
                  ]}
                  dataSource={data?.rxDetlList || []}
                />
              </Tabs.TabPane>
              <Tabs.TabPane tab="处方诊断信息" key="4">
                <Table
                  rowKey={() => `row_${Math.random()}`}
                  pagination={false}
                  size="small"
                  bordered
                  columns={[
                    {
                      title: "诊断类别",
                      align: "center",
                      dataIndex: "diag_type",
                      ellipsis: true,
                    },
                    {
                      title: "主诊断标志",
                      align: "center",
                      dataIndex: "maindiag_flag",
                      ellipsis: true,
                      render: (_, m) => {
                        return m.maindiag_flag === "1" ? "是" : "否"
                      },
                    },
                    {
                      title: "诊断排序号",
                      align: "center",
                      dataIndex: "diag_srt_no",
                      ellipsis: true,
                    },
                    {
                      title: "诊断代码",
                      align: "center",
                      dataIndex: "diag_code",
                      ellipsis: true,
                    },
                    {
                      title: "诊断名称",
                      align: "center",
                      dataIndex: "diag_name",
                      ellipsis: true,
                    },
                    {
                      title: "中医病名代码",
                      align: "center",
                      dataIndex: "tcm_dise_code",
                      ellipsis: true,
                    },
                    {
                      title: "中医病名名称",
                      align: "center",
                      dataIndex: "tcm_dise_name",
                      ellipsis: true,
                    },
                    {
                      title: "中医证候代码",
                      align: "center",
                      dataIndex: "tcmsymp_code",
                      ellipsis: true,
                    },
                    {
                      title: "中医证候",
                      align: "center",
                      dataIndex: "tcmsymp",
                      ellipsis: true,
                    },
                  ]}
                  dataSource={data?.rxDiseList || []}
                />
              </Tabs.TabPane>
            </Tabs>
          </Col>
          <Col span={6}>
            <Form.Item label="开方机构" name="prescription">
              {data?.data?.fixmedins_name}
            </Form.Item>
            <Form.Item label="开方机构编码" name="prescription">
              {data?.data?.fixmedins_code}
            </Form.Item>
            <Form.Item label="医保处方编码" name="prescription">
              {data?.data?.hi_rxno}
            </Form.Item>
            <Form.Item
              label="药师"
              name="pharId"
              rules={[{ required: true, message: "请输入" }]}
            >
              <Select allowClear>
                {doctors
                  .filter((d) => d.auditPermissionsFlag == 1)
                  .map((d) => (
                    <Select.Option key={d.id} value={d.id}>
                      {d.realname}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="复诊药师"
              name="rchkPharId"
              rules={[{ required: true, message: "请输入" }]}
            >
              <Select allowClear>
                {doctors
                  .filter((d) => d.auditPermissionsFlag == 1)
                  .map((d) => (
                    <Select.Option key={d.id} value={d.id}>
                      {d.realname}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="配药人"
              name="dspeerId"
              rules={[{ required: true, message: "请输入" }]}
            >
              <Select allowClear>
                {doctors
                  .filter((d) => d.auditPermissionsFlag == 1)
                  .map((d) => (
                    <Select.Option key={d.id} value={d.id}>
                      {d.realname}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="处方审核意见"
              name="rxChkOpnn"
              rules={[{ required: true, message: "请输入" }]}
            >
              <Input allowClear />
            </Form.Item>
            <Form.Item
              label="审核结果"
              name="rxChkStas"
              rules={[{ required: true, message: "请选择" }]}
            >
              <Radio.Group>
                <Radio value={1}>通过</Radio>
                <Radio value={0}>不通过</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Modal
        title="外配处方药品"
        width={1200}
        maskClosable={false}
        visible={medicalVisible}
        confirmLoading={medicalLoading}
        onOk={() => {
          setMedicalLoading(true)
          setMedicalVisible(false)
          setTimeout(() => {
            onOk(medicalItemList, data?.rxDiseList?.map((d: any) => {
              return {
                ...d,
                name: d.diag_name,
                icds: d.diag_code
              }
            }), data?.data?.hi_rxno)
            setMedicalLoading(false)
          }, 100)
        }}
        onCancel={() => {
          setMedicalVisible(false)
        }}
      > 
        <EditableList
          pagination={false}
          size="small"
          bordered
          rowKey={() => `row_${Math.random()}`}
          columns={[
            {
              title: "医疗目录编码",
              align: "center",
              dataIndex: "med_list_codg",
              width: "15rem",
              ellipsis: true,
            },
            {
              title: "药品商品名",
              align: "center",
              dataIndex: "drug_prodname",
              ellipsis: true,
            },
            {
              title: "药品剂型",
              align: "center",
              dataIndex: "drug_dosform",
              ellipsis: true,
            },
            {
              title: "药品规格",
              align: "center",
              dataIndex: "drug_spec",
              ellipsis: true,
            },
            {
              title: "药品总量",
              align: "center",
              dataIndex: "drug_cnt",
              ellipsis: true,
            },
            {
              title: "药品总量单位",
              align: "center",
              dataIndex: "drug_dosunt",
              ellipsis: true,
            },
          ]}
          dataSource={medicalList || []}
        />
        <EditableList
          bordered
          // loading={loading}
          sticky
          className={styles.table}
          rowKey={(v: any, i) => {
              return `${v.id}`
          }}
          style={{ marginTop: 20 }}
          dataSource={medicalItemList || []}
          columns={[
            {
              title: "药品名称",
              align: "center",
              dataIndex: "name",
              ellipsis: true,
            },
            {
              title: "药品剂型",
              align: "center",
              dataIndex: "doseCategory",
              ellipsis: true,
            },
            {
              title: "药品规格",
              align: "center",
              dataIndex: "spec",
              ellipsis: true,
            },
            {
              title: "库存数量",
              align: "center",
              dataIndex: "count",
              ellipsis: true,
            },
            {
              title: "拆零库存数量",
              align: "center",
              dataIndex: "splitCount",
              ellipsis: true,
            },
            {
              title: "销售数量",
              align: "center",
              dataIndex: "sellCnt",
              editable: true,
              ellipsis: true,
              rules: [
                {
                  required: true,
                },
              ],
              onSave: (prev, next) => {
                const data = {  ...prev, ...next }
                setMedicalItemList(medicalItemList?.map((item: any) => item.id === data.id ? data : item))
              },
            },
            {
              title: "单位",
              align: "center",
              dataIndex: "accountUnit",
              ellipsis: true,
              render: function Element(_, t) {
                return (
                  t.splitTag == 1 ? <Select
                    style={{ width: '100%' }}
                    value={t.sellUnit}
                    onChange={(v) => {
                      setMedicalItemList(medicalItemList?.map((item: any) => item.id === t.id ? {...item, sellUnit: v} : item))
                    }}
                  >
                    <Select.Option value={t.accountUnit}>{t.accountUnit}</Select.Option>
                    <Select.Option value={t.splitUnit}>{t.splitUnit}</Select.Option>
                  </Select> : t.accountUnit
                )
              }
            },
          ]}
          pagination={false}
        />
      </Modal>
    </Modal>
  )
}
